import gql from "graphql-tag";

export const BANK_ACCOUNT_TRANSACTIONS_QUERY = gql`
    query bankAccountTransactions($filter: BankAccountTransactionFilterInput, $includeVersions: Boolean = false) {
        bankAccountTransactions(filter: $filter) {
            _id
            clientId
            client {
                _id
                name
            }
            instrumentId
            instrument {
                _id
                name
                bic
                iban
                currency
            }
            date
            externalId
            amount
            status
            reference
            description
            additionalInformation
            createTimestamp
            updateTimestamp
            updateUserId
            updateUserInfo {
                name
            }
            versions @include(if: $includeVersions)
        }
    }
`;
